export interface ShiftInfo {
  shift: 'A' | 'B';
  startTime: string;
  endTime: string;
}

export class ShiftService {
  /**
   * Get current shift based on time
   * @returns {ShiftInfo} Current shift information
   */
  static getCurrentShift(): ShiftInfo {
    const currentTime = new Date();
    const currentHour = currentTime.getHours();
    
    // Default shift times (can be made configurable later)
    const shiftAStart = 8; // 8 AM
    const shiftAEnd = 20;  // 8 PM
    
    // Determine current shift
    if (currentHour >= shiftAStart && currentHour < shiftAEnd) {
      return {
        shift: 'A',
        startTime: '08:00',
        endTime: '20:00'
      };
    } else {
      return {
        shift: 'B',
        startTime: '20:00',
        endTime: '08:00'
      };
    }
  }

  /**
   * Get shift display name
   * @param shift - Shift type ('A' or 'B')
   * @returns {string} Formatted shift name
   */
  static getShiftDisplayName(shift: 'A' | 'B'): string {
    return shift === 'A' ? 'Shift A (8 AM - 8 PM)' : 'Shift B (8 PM - 8 AM)';
  }

  /**
   * Get shift icon/indicator
   * @param shift - Shift type ('A' or 'B')
   * @returns {string} Icon emoji
   */
  static getShiftIcon(shift: 'A' | 'B'): string {
    return shift === 'A' ? '☀️' : '🌙';
  }

  /**
   * Get shift color for UI
   * @param shift - Shift type ('A' or 'B')
   * @returns {string} CSS color class
   */
  static getShiftColor(shift: 'A' | 'B'): string {
    return shift === 'A' ? 'text-yellow-600 bg-yellow-50' : 'text-blue-600 bg-blue-50';
  }

  /**
   * Get active shift employee for a machine group
   * @param group - Machine group object
   * @param shift - Shift type ('A' or 'B')
   * @returns {object|null} Active shift employee or null
   */
  static getActiveShiftEmployee(group: any, shift: 'A' | 'B') {
    if (shift === 'A') {
      return group.shiftAEmployee || null;
    } else {
      return group.shiftBEmployee || null;
    }
  }

  /**
   * Check if current time is within shift hours
   * @param shift - Shift type ('A' or 'B')
   * @returns {boolean} True if currently in shift hours
   */
  static isCurrentShift(shift: 'A' | 'B'): boolean {
    const currentShift = this.getCurrentShift();
    return currentShift.shift === shift;
  }
}
